import {MessageCodes} from "../MessageCodes";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultTable from "../../Table/ResultTable";
import ResultCellHighlight from "../../Table/ResultCellHighlight";
import EmptyLine from "../../EmptyLine";
import ResultText from "../ResultText";
import HecRasHelper from "../../../Helpers/HecRasHelper";
import ComparisonCSName from "../../ComparisonCSName";

const renderSections = (row) => {
    const components = []
    row.data.forEach((x, idx) => {
        x.data.forEach((r, idy) => {
            // console.log(r.base_start_sta, r.cmp_start_sta, HecRasHelper.isUndefined(r.base_start_sta), HecRasHelper.isUndefined(r.cmp_start_sta))
            components.push(
                <>
                    <ResultRow>
                        {
                            idy === 0 && (
                                <ResultBodyCell rowSpan={x.data.length} style={{textAlign: 'left', verticalAlign: 'bottom', width: 125}}><ComparisonCSName csName={r.cross_section} /></ResultBodyCell>
                            )
                        }
                        <ResultBodyCell style={{textAlign: 'right'}}>{HecRasHelper.isUndefined(r.base_start_sta)}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{HecRasHelper.isUndefined(r.base_end_sta)}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{HecRasHelper.isUndefined(r.base_elev)}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{HecRasHelper.isUndefined(r.base_perm)}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(HecRasHelper.isUndefined(r.base_start_sta), HecRasHelper.isUndefined(r.cmp_start_sta))}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(HecRasHelper.isUndefined(r.base_end_sta),  HecRasHelper.isUndefined(r.cmp_end_sta))}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(HecRasHelper.isUndefined(r.base_elev),  HecRasHelper.isUndefined(r.cmp_elev))}</ResultBodyCell>
                        <ResultBodyCell style={{textAlign: 'right'}}>{ResultCellHighlight(HecRasHelper.isUndefined(r.base_perm),  HecRasHelper.isUndefined(r.cmp_perm))}</ResultBodyCell>
                    </ResultRow>
                </>
            )
        })
    })
    return components
}

const RenderDescription = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Compare.TIEFF001.error_id: {
            return (
                <>
                    <ResultText>
                        There are differences in the ineffective flow areas between {globalVariables?.sel_plan_title || 'base'} and {globalVariables?.tar_plan_title || 'comparison'} plan at the following {row.data.length} cross-sections:
                        <EmptyLine />
                    </ResultText>
                    <ResultTable>
                        <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell rowSpan={3} style={{textAlign: 'left', verticalAlign: 'bottom'}}>River Station</ResultHeaderCell>
                            <ResultHeaderCell colSpan={8}>Ineffective Flow Areas</ResultHeaderCell>
                        </ResultRow>
                        <ResultRow>
                            <ResultHeaderCell colSpan={4}>{globalVariables?.sel_plan_title || 'Base'}</ResultHeaderCell>
                            <ResultHeaderCell colSpan={4}>{globalVariables?.tar_plan_title || 'Comparison'}</ResultHeaderCell>
                        </ResultRow>
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'right', width: 80}}>Start Sta</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right', width: 80}}>End Sta</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right', width: 80}}>Elev</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right', width: 80}}>Perm</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right', width: 80}}>Start Sta</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right', width: 80}}>End Sta</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right', width: 80}}>Elev</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right', width: 80}}>Perm</ResultHeaderCell>
                        </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                        {
                            renderSections(row)
                        }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}

export const C13 = {
    RenderDescription,
}